export const api = "https://blood-bank-mern-backend.vercel.app/"
//   "https://blood-bank-mern-backend.vercel.app/"
// "http://localhost:5050/"